import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import ErrorLabel from 'app/components/ErrorLabel/ErrorLabel'
import { getIdentityEmail } from 'store/entities/identity/selectors'

const mapStateToProps = state => ({
  email: getIdentityEmail(state),
})

const ProfileFormEmailInput = ({ t, input, meta: { error, touched }, email }) => (
  <div className="profile-input profile-input--email">
    <div className="profile-input__label-wrapper">
      <label htmlFor="profile-input-email" className="profile-input__label">
        {t('Your Email')}
      </label>
    </div>
    <input
      type="email"
      placeholder={email}
      id="profile-input-email"
      {...input}
      disabled
      className={`profile-input__field ${touched && error ? 'error' : ''}`}
    />
    {touched && error && <ErrorLabel before="Email" htmlFor="profile-input-email" error={error} />}
  </div>
)

ProfileFormEmailInput.displayName = 'ProfileFormEmailInput'

const ProfileFormEmailInputContainer = connect(mapStateToProps)(ProfileFormEmailInput)

export default withTranslation('user')(ProfileFormEmailInputContainer)
